import { Observable, ReplaySubject, map, share } from 'rxjs';

export function share1UntilNoRefs<T>(source$: Observable<T>): Observable<T> {
  return source$.pipe(
    share({
      connector: () => new ReplaySubject(1),
      resetOnRefCountZero: true,
      resetOnComplete: true,
      resetOnError: true,
    })
  );
}

export function some<T>(
  operator: (value: T) => boolean = (): boolean => true
): (source$: Observable<T[] | null>) => Observable<boolean> {
  return (source$: Observable<T[] | null>) =>
    source$.pipe(
      map((array) => {
        if (!array) return false;
        return array.some(operator);
      })
    );
}
